import { PlaneTicket } from "@/api/dtos";
import { AdminContext } from "@/contexts/AdminContext";
import { faDownload, faEye } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Grid, Typography, styled } from "@mui/material";
import {
	FileUpload,
	IFileUploadView,
	ITableArrayFieldColumn,
	Input,
	TableArrayField,
	Text,
} from "@ngt/forms";
import { FC, useContext } from "react";

const ViewContainerDiv = styled('div')(({}) => ({
	display: 'flex'
}));

const ViewIconButton = styled(Button)(({ theme }) => ({
	minWidth: 0,
	padding: theme.spacing(0, 1.25),
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	marginLeft: theme.spacing(2),
	height: '32px',

	'& > *': {
		opacity: 0.9
	}
}));

const DownloadFileView: FC<IFileUploadView> = ({
	FileUploadViewProps: {
		value,
		downloadLink,
		viewLink
	}
}) => {
	return (
		<ViewContainerDiv>
			{
				!!value?.exists && !!value?.image && (
					<ViewIconButton
						variant="contained"
						color="secondary"
						//@ts-ignore
						component="a"
						href={viewLink}
						target="_blank"
					>
						<FontAwesomeIcon icon={faEye} fixedWidth />
					</ViewIconButton>
				)
			}
			{
				!!value?.exists && (
					<ViewIconButton
						variant="contained"
						color="secondary"
						//@ts-ignore
						component="a"
						href={downloadLink}
					>
						<FontAwesomeIcon icon={faDownload} fixedWidth />
					</ViewIconButton>
				)
			}
		</ViewContainerDiv>
	);
};

const planeTicketColumns: Array<ITableArrayFieldColumn<PlaneTicket>> = [
	{
		TableHeadCellProps: {
			sx: {
				width: "50%",
			},
		},
		propertyPath: "name",
		headerLabel: "Name",
		content: <Input component={Text} variant="standard" />,
	},
	{
		TableHeadCellProps: {
			sx: {
				width: "50%",
			},
		},
		propertyPath: "ticket",
		headerLabel: "Ticket",
		content: <Input
					component={FileUpload}
				/>,
	},
];

const readOnlyPlaneTicketColumns: Array<ITableArrayFieldColumn<PlaneTicket>> = [
	{
		propertyPath: "name",
		headerLabel: "Name",
		content: <Input component={Text} variant="standard" disabled />,
	},
	{
		TableHeadCellProps: {
			sx: {
				width: '120px',
			},
		},
		propertyPath: "ticket",
		headerLabel: "Ticket",
		content: <Input
						label="Plane Ticket"
						component={FileUpload}
						view={DownloadFileView}
					/>,
	},
];

//these props hide the delete and add buttons for speakers.
const hideButtonProps = {
	sx: {
		display: 'none'
	}
};

const SpeakerTicketsSection: FC = () => {
	const adminSection = useContext(AdminContext);

	return (
		<>
			<Grid item sm={12}>
				<Typography variant="h2">Tickets</Typography>
			</Grid>
			{!!adminSection ? (
				<Grid item sm={12}>
					<TableArrayField
						propertyPath="planeTickets"
						entityName="Plane Tickets"
						columns={planeTicketColumns}
					/>
				</Grid>
			) : (
				<Grid item sm={12}>
					<TableArrayField
						propertyPath="planeTickets"
						columns={readOnlyPlaneTicketColumns}
						DeleteButtonProps={hideButtonProps}
						AddButtonProps={hideButtonProps}
						entityName="Plane Tickets"
					/>
				</Grid>
			)}
		</>
	);
};

export default SpeakerTicketsSection;
